export const REASON_IDS = {
  LOST_SIM: 'LOST_SIM',
  SHORT_TERM: 'SHORT_TERM',
  BETTER_DEAL_ELSEWHERE: 'BETTER_DEAL_ELSEWHERE',
  SPECIAL_OFFER_OVER: 'SPECIAL_OFFER_OVER',
  POOR_COVERAGE: 'POOR_COVERAGE',
  POOR_CUSTOMER_SERVICE: 'POOR_CUSTOMER_SERVICE',
  COULDNT_GET_SIM_WORKING: 'COULDNT_GET_SIM_WORKING',
  NEED_A_HANDSET: 'NEED_A_HANDSET',
  OTHER: 'OTHER',
  OTHER_FREE_TEXT: 'OTHER_FREE_TEXT',
  ADDITIONAL_COMMENTS: 'ADDITIONAL_COMMENTS',
}

export const REASONS = [
  {
    id: REASON_IDS.LOST_SIM,
    description: 'My phone/SIM was lost or stolen',
    hasFreeText: false,
  },
  {
    id: REASON_IDS.SHORT_TERM,
    description: 'I only needed SMARTY for a few months',
    hasFreeText: false,
  },
  {
    id: REASON_IDS.BETTER_DEAL_ELSEWHERE,
    description: 'I can get a better deal elsewhere',
    hasFreeText: false,
  },
  {
    id: REASON_IDS.SPECIAL_OFFER_OVER,
    description: 'My deal or special offer is over',
    hasFreeText: false,
  },
  {
    id: REASON_IDS.POOR_COVERAGE,
    description: 'Poor coverage or signal',
    hasFreeText: false,
  },
  {
    id: REASON_IDS.POOR_CUSTOMER_SERVICE,
    description: 'Poor customer service',
    hasFreeText: false,
  },
  {
    id: REASON_IDS.COULDNT_GET_SIM_WORKING,
    description: 'I couldn’t get my SIM working',
    hasFreeText: false,
  },
  {
    id: REASON_IDS.NEED_A_HANDSET,
    description: 'I also need a handset',
    hasFreeText: false,
  },
  {
    id: REASON_IDS.OTHER,
    description: 'Other',
    hasFreeText: true,
  },
]
